import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

export const NavBar = ({ handleNavVal, onSendDataVal }) => {
    //const dataCh = 'some data';
 // Log the received prop to confirm it's passed correctly
 //console.log('onSendDataVal:', onSendDataVal);
//  const handleEnquireClick = () => {
//     onSendDataVal(true);  // Calls handleChange in the parent, which in turn calls onSendData
//     handleNavVal(false);   // Closes the navigation
// };

    // // Log to confirm that the props are received correctly (can be used for debugging)
    // useEffect(() => {
    //     console.log('handleNavVal:', handleNavVal);
    //     console.log('onClick function:', onClick);
    // }, [handleNavVal, onClick]);

    return (
        <>
            <ul>
                <li>
                    <NavLink
                        className="animate"
                        to="/"
                        onClick={() => handleNavVal(false)}
                    >
                        Home
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        className="animate"
                        to="/our-collection"
                        onClick={() => handleNavVal(false)}
                    >
                        Our collection
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        className="animate"
                        to="/customized"
                        onClick={() => handleNavVal(false)}
                    >
                        Customized
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        className="animate"
                        to="/about-us"
                        onClick={() => handleNavVal(false)}
                    >
                        About us
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        className="animate"
                        to="/contact"
                        onClick={() => handleNavVal(false)}
                    >
                        Contact
                    </NavLink>
                </li>
                <li className="mobile">
                    <div className="btn-find-home">
                        <a
                            className="btn enq-b"
                            onClick={() => {
                                handleNavVal(false);
                                onSendDataVal(true);
                                }}
                        >
                            Enquire now
                        </a>
                        <NavLink
                            className="btn sbc"
                            to="/our-collection"
                            onClick={() => handleNavVal(false)}
                        >
                            <span className="sbc-icon">
                                <b className="circle"></b>
                                <b className="rectangle"></b>
                            </span>
                            Search by category
                        </NavLink>
                    </div>
                </li>
                <li>
                    <a
                        className="menu mobile ir"
                        onClick={() => handleNavVal(false)}
                    >
                        Menu
                    </a>
                </li>
            </ul>
        </>
    );
};
